import { EMPTY_FIELD } from 'constants/emptyField';

import { Box } from 'shared/mui/Box';
import { Chip } from 'shared/mui/Chips';
import { PresetItem } from 'types/embedded/preset';
import { formatCurrency } from 'utils';

type Props = {
  items: PresetItem[];
};

export const PresetsListAmountChips: React.FC<Props> = ({ items }) => {
  const amounts = items.map((i) => formatCurrency(Number(i.amount)));

  if (!amounts.length) {
    return <>{EMPTY_FIELD}</>;
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px', overflow: 'hidden' }}>
      {amounts.map((amount, index) => (
        <Chip key={index} label={amount} sx={{ flexShrink: 0 }} />
      ))}
    </Box>
  );
};
